import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Eraser } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const ChatHistoryClear = ({ endpoint, queryKey, testId }) => {
  const [open, setOpen] = useState(false);
  const qc = useQueryClient();
  const clear = useMutation({ mutationFn: async () => {
    await qc.cancelQueries({ queryKey });
    return (await api.post(endpoint)).data;
  }, onSuccess: data => {
    qc.setQueryData(queryKey, old => ({ ...old, messages: [], cleared_before: data.cleared_before }));
    qc.invalidateQueries({ queryKey });
    setOpen(false);
  } });
  return <>
    <button type="button" data-testid={testId} title="Clear your chat history" aria-label="Clear your chat history" onClick={() => setOpen(true)} className="p-1.5 shrink-0 text-white/50 hover:text-cyan-300"><Eraser className="h-3.5 w-3.5" /></button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent data-testid={`${testId}-dialog`} className="max-w-sm bg-[hsl(222_22%_8%)] border-white/15">
      <DialogHeader><DialogTitle data-testid={`${testId}-title`}>Clear your chat view?</DialogTitle><DialogDescription data-testid={`${testId}-description`}>Earlier messages in this room will stay hidden for your account. Other players keep their own history. Saved chat messages expire after 7 days.</DialogDescription></DialogHeader>
      {clear.isError && <p data-testid={`${testId}-error`} role="alert" className="text-sm text-red-300">{apiError(clear.error, "History could not be cleared.")}</p>}
      <Button data-testid={`${testId}-confirm`} disabled={clear.isPending} onClick={() => clear.mutate()}>{clear.isPending ? "Clearing…" : "Clear my history"}</Button>
    </DialogContent></Dialog>
  </>;
};